/*
 * @Description  :
 * @Author       : 王帅
 * @Date         : 2022-10-18 09:55:10
 * @LastEditors  : 王帅
 * @LastEditTime : 2025-10-28 16:18:04
 * @FilePath     : \ngs_share_login\src\store\modules\common.js
 */
import { bmStorage } from 'static/commonplugin/tool'

const common = {
	namespaced: true,
	state: {
		breadList: [],
		token: bmStorage.localStorage.get('token'),
		curTab: 'home',
		previewList: [], // 图片预览专用
		previewUrl: '', // 预览地址 iframe接入
		previewName: '' // 预览文件名称 iframe接入
	},
	mutations: {
		// 面包屑
		UPDATE_BREAD_CRUMB(state, arr) {
			state.breadList = arr
		},
		// 存储token
		UPDATE_TOKEN(state, token) {
			state.token = token
		},
		// 更新tab
		UPDATE_TAB(state, tab) {
			state.curTab = tab
		},
		SET_PREVIEWLIST: (state, list) => {
			state.previewList = list
		},
		SET_PREVIEWURL: (state, url) => {
			state.previewUrl = url
		},
		SET_PREVIEWNAME: (state, name) => {
			state.previewName = name
		}
	},
	actions: {
		// 更新面包屑
		updateBreadCrumb({ commit }, arr) {
			commit('UPDATE_BREAD_CRUMB', arr)
		},
		// 存储token
		updateToken({ commit }, token) {
			commit('UPDATE_TOKEN', token)
		},
		//更新tab
		updateTab({ commit }, tab) {
			commit('UPDATE_TAB', tab)
		},
		// el-image 的图片图片预览效果
		setPreviewList({ commit }, list) {
			commit('SET_PREVIEWLIST', list)
		},
		// iframe 文件预览效果
		setPreviewUrl({ commit }, url) {
			commit('SET_PREVIEWURL', url)
		},
		// iframe 文件预览效果
		setPreviewName({ commit }, name) {
			commit('SET_PREVIEWNAME', name)
		}
	}
}

export default common



// WEBPACK FOOTER //
// ./src/store/modules/common.js